<div class="secrets-card">

  <div class="secrets-header">
    <div class="secrets-header-title">
      <i class="ri-shield-keyhole-line"></i>
      <span i18n="@@placeholder-secret">Platzhalter Secrets</span>
    </div>
    <span class="secrets-count-badge">
      {{ this.secretService.projectSecrets.length }} Secrets
    </span>
  </div>

  @if (this.rss.botConfig.projectId === null || this.rss.botConfig.projectId === "null") {
  <div class="secrets-empty-state">
    <div class="secrets-empty-icon"><i class="ri-lock-line"></i></div>
    <p>Weise dem Bot ein Projekt zu, um Projektgeheimnisse zu verwenden.</p>
  </div>
  <hr class="secrets-divider">
  <p class="secrets-hint">
    Sobald Secrets angelegt sind, werden ihre Platzhalter hier angezeigt und können in Webhooks verwendet werden.
  </p>
  }

  @else if (this.secretService.projectSecrets.length === 0) {
  <div class="secrets-empty-state">
    <div class="secrets-empty-icon"><i class="ri-lock-line"></i></div>
    <p i18n="@@no-secrets-defined">Keine Projektgeheimnisse definiert.</p>
    <a
      [routerLink]="['/bot-admin','project',this.rss.botConfig.projectId,'secrets']"
      i18n="@@manage-secrets"
    >Geheimnisse verwalten &rsaquo;</a>
  </div>
  <hr class="secrets-divider">
  <p class="secrets-hint">
    Sobald Secrets angelegt sind, werden ihre Platzhalter hier angezeigt und können in Webhooks verwendet werden.
  </p>
  }
  @else {
  <div class="secrets-list">
    @for (secret of this.secretService.projectSecrets; track $index) {
    <span class="secret-chip">{{ this.projectSecretPlaceHolderByName(secret.name) }}</span>
    }
  </div>
  <div class="secrets-manage-link">
    <a [routerLink]="['/bot-admin','project',this.rss.botConfig.projectId,'secrets']">
      <i class="ri-external-link-line"></i>
      <span i18n="@@manage-secrets-plain">Geheimnisse verwalten</span>
    </a>
  </div>
  }
</div>